import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
  useLocation
} from "react-router-dom";
import InternForm from "./InternForm";
import InternList from "./InternList";
import AdminPanel from "./AdminPanel";
import LoginPage from "./LoginPage";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";
import "./styles.css"; // Make sure this import is at the top

function Header({ user }) {
  const location = useLocation();

  return (
    <nav className="header">
      <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
        <img src="/Texas A&M University_REV.png" alt="SWE Logo" className="logo" />
        <Link to="/submit" className={`nav-link ${location.pathname === "/submit" ? "active" : ""}`}>
          Submit Internship
        </Link>
        <Link to="/internships" className={`nav-link ${location.pathname === "/internships" ? "active" : ""}`}>
          Past SWE Internships
        </Link>
        {user && (
          <Link to="/admin" className={`nav-link ${location.pathname === "/admin" ? "active" : ""}`}>
            Admin Access
          </Link>
        )}
      </div>
      <div className="auth-area">
        {user ? (
          <>
            <span style={{ color: "white", marginRight: "1rem" }}>{user.email}</span>
            <button onClick={() => auth.signOut()} className="header-button">
              Log out
            </button>
          </>
        ) : (
          <Link to="/login">
            <button className="header-button">Log In</button>
          </Link>
        )}
      </div>
    </nav>
  );
}

function ProtectedRoute({ user, children }) {
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  const [user] = useAuthState(auth);

  return (
    <Router>
      <Header user={user} />
      <Routes>
        <Route path="/submit" element={<InternForm />} />
        <Route path="/internships" element={<InternList />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute user={user}>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<div className="not-found">🚫 Page not found</div>} />
      </Routes>
    </Router>
  );
}

export default App;
